import LegalLayout from '../components/LegalLayout';

const navLinks = [
  { label: 'Obchodné podmienky', href: '/obchodne-podmienky' },
  { label: 'Ochrana súkromia', href: '/ochrana-sukromia' },
];

const sections = [
  {
    title: 'Čo sú súbory cookies',
    content: (
      <>
        <p>Cookies sú malé textové súbory, ktoré sa ukladajú vo vašom prehliadači pri návšteve webovej stránky. Pomáhajú stránke zapamätať si vaše preferencie, analyzovať návštevnosť a zlepšovať používateľský zážitok.</p>
        <p className="mt-2">Cookies neobsahujú osobne identifikovateľné informácie samé o sebe, avšak v kombinácii s ďalšími údajmi môžu byť použité na identifikáciu osoby. Preto ich spracovanie podlieha pravidlám GDPR a nášmu dokumentu <a href="/ochrana-sukromia" className="text-orange-400 hover:underline">Ochrana osobných údajov</a>.</p>
      </>
    ),
  },
  {
    title: 'Typy cookies, ktoré používame',
    content: (
      <>
        <div className="space-y-5 mt-1">
          {[
            {
              type: 'Nevyhnutné cookies',
              badge: 'Vždy aktívne',
              badgeColor: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-400',
              desc: 'Tieto cookies sú nevyhnutné pre správne fungovanie webovej stránky. Bez nich by nebolo možné používať základné funkcie ako navigáciu a zabezpečenie. Nie je možné ich zakázať.',
              examples: ['session_id', 'csrf_token', 'lang_pref'],
              duration: 'Trvanie relácie alebo do 1 roka',
            },
            {
              type: 'Analytické cookies',
              badge: 'Vyžadujú súhlas',
              badgeColor: 'bg-amber-500/10 border-amber-500/20 text-amber-400',
              desc: 'Používame ich na pochopenie toho, ako návštevníci interagujú s webom. Všetky dáta sú anonymizované a slúžia výlučne na zlepšenie obsahu a štruktúry stránky.',
              examples: ['_ga (Google Analytics 4)', '_gid', '_gat'],
              duration: 'Do 26 mesiacov',
            },
            {
              type: 'Marketingové cookies',
              badge: 'Vyžadujú súhlas',
              badgeColor: 'bg-amber-500/10 border-amber-500/20 text-amber-400',
              desc: 'Slúžia na zobrazenie relevantnějších reklám. Môžu sledovať vašu aktivitu naprieč stránkami. Ak spravujeme marketingové kampane pre našich klientov, môžu byť aktívne pixely tretích strán (Meta Pixel, Google Tag).',
              examples: ['_fbp (Meta)', '_gcl_au (Google Ads)'],
              duration: 'Do 90 dní',
            },
            {
              type: 'Funkčné cookies',
              badge: 'Odporúčané',
              badgeColor: 'bg-zinc-600/30 border-zinc-600/40 text-zinc-400',
              desc: 'Pamätajú si vaše preferencie (jazyk, región) a zlepšujú komfort používania. Nezbierajú osobné informácie.',
              examples: ['ui_lang', 'ui_theme'],
              duration: 'Do 1 roka',
            },
          ].map((item) => (
            <div key={item.type} className="bg-zinc-800/30 border border-zinc-700/40 rounded-xl p-5">
              <div className="flex flex-wrap items-center gap-2.5 mb-3">
                <h3 className="text-white font-semibold text-sm">{item.type}</h3>
                <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full border ${item.badgeColor}`}>
                  {item.badge}
                </span>
              </div>
              <p className="text-zinc-400 text-xs leading-relaxed mb-3">{item.desc}</p>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-zinc-600">
                <span><strong className="text-zinc-500">Príklady: </strong>{item.examples.join(', ')}</span>
                <span><strong className="text-zinc-500">Platnosť: </strong>{item.duration}</span>
              </div>
            </div>
          ))}
        </div>
      </>
    ),
  },
  {
    title: 'Cookies tretích strán',
    content: (
      <>
        <p>Na tejto stránke môžu byť aktívne cookies od týchto tretích strán:</p>
        <div className="mt-3 space-y-2">
          {[
            { name: 'Google LLC', service: 'Google Analytics 4, Google Ads', policy: 'policies.google.com/privacy' },
            { name: 'Meta Platforms, Inc.', service: 'Meta Pixel (Facebook, Instagram)', policy: 'www.facebook.com/privacy/policy' },
          ].map((t) => (
            <div key={t.name} className="flex flex-col sm:flex-row sm:items-center gap-2 bg-zinc-800/40 border border-zinc-700/40 rounded-lg px-4 py-3">
              <div className="flex-1">
                <p className="text-zinc-300 text-sm font-medium">{t.name}</p>
                <p className="text-zinc-600 text-xs">{t.service}</p>
              </div>
              <a
                href={`https://${t.policy}`}
                target="_blank"
                rel="nofollow noreferrer"
                className="text-xs text-orange-400 hover:text-orange-300 whitespace-nowrap flex items-center gap-1"
              >
                <i className="ri-external-link-line" />
                Zásady ochrany
              </a>
            </div>
          ))}
        </div>
      </>
    ),
  },
  {
    title: 'Ako spravovať a odmietnuť cookies',
    content: (
      <>
        <p>Máte plnú kontrolu nad tým, aké cookies akceptujete. Môžete ich spravovať nasledovne:</p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>
            <strong className="text-zinc-300">Nastavenia prehliadača</strong> - Väčšina prehliadačov umožňuje zablokovanie alebo vymazanie cookies v nastaveniach. Upozorňujeme, že zakázanie nevyhnutných cookies môže obmedziť funkcionalitu webu.
          </li>
          <li>
            <strong className="text-zinc-300">Google Analytics Opt-out</strong> - Môžete nainštalovať <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="nofollow noreferrer" className="text-orange-400 hover:underline">doplnok prehliadača</a>, ktorý zabraňuje zberu dát Google Analytics.
          </li>
          <li>
            <strong className="text-zinc-300">Nastavenia reklám Google</strong> - Personalizáciu reklám môžete spravovať na <a href="https://adssettings.google.com" target="_blank" rel="nofollow noreferrer" className="text-orange-400 hover:underline">adssettings.google.com</a>.
          </li>
          <li>
            <strong className="text-zinc-300">Meta reklamy</strong> - Nastavenia na <a href="https://www.facebook.com/adpreferences" target="_blank" rel="nofollow noreferrer" className="text-orange-400 hover:underline">facebook.com/adpreferences</a>.
          </li>
        </ul>
        <div className="mt-4 bg-zinc-800/40 border border-zinc-700/40 rounded-xl p-4">
          <p className="text-zinc-400 text-xs leading-relaxed">
            <strong className="text-zinc-300">Nastavenia prehliadačov: </strong>
            <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="nofollow noreferrer" className="text-orange-400 hover:underline mr-3">Chrome</a>
            <a href="https://support.mozilla.org/kb/cookies-information-websites-store" target="_blank" rel="nofollow noreferrer" className="text-orange-400 hover:underline mr-3">Firefox</a>
            <a href="https://support.apple.com/guide/safari/sfri11471" target="_blank" rel="nofollow noreferrer" className="text-orange-400 hover:underline mr-3">Safari</a>
            <a href="https://support.microsoft.com/topic/delete-and-manage-cookies" target="_blank" rel="nofollow noreferrer" className="text-orange-400 hover:underline">Edge</a>
          </p>
        </div>
      </>
    ),
  },
  {
    title: 'Aktualizácie tohto dokumentu',
    content: (
      <>
        <p>Zoznam cookies sa môže meniť pri aktualizácii webovej stránky alebo zavádzaní nových nástrojov. O podstatných zmenách vás informujeme upozornením na stránke alebo e-mailom.</p>
        <p className="mt-2">Pre ďalšie otázky týkajúce sa cookies a spracovania osobných údajov kontaktujte nás na <a href="mailto:info@boostio.sk" className="text-orange-400 hover:underline">info@boostio.sk</a>.</p>
        <p className="mt-2">Tento dokument je platný od <strong className="text-zinc-300">1. januára 2024</strong>.</p>
      </>
    ),
  },
];

export default function CookiesPage() {
  return (
    <LegalLayout
      title="Cookies"
      subtitle="Informácie o tom, ako používame súbory cookies na webovej stránke boostio.sk."
      updated="1. januára 2024"
      sections={sections}
      navLinks={navLinks}
    />
  );
}
